import React from 'react';
import _ from 'lodash';

import {
  useEditCustomerModalQuery,
  useSaveCustomerMutation
} from 'generated/graphql';

import * as types from './types';
import { errorUtil } from 'iron-forge-react-modules';



export interface IData {
  isInNetSuite: boolean;
  formState: types.IFormState;
}

export function useQuery(customerId: string) {
  const tuple = useEditCustomerModalQuery({
    variables: {
      customerId
    }
  });

  return React.useMemo(
    () => {
      const customer = tuple.data?.customer;
      const data: IData = {
        isInNetSuite: !_.isNil(customer?.netSuiteRecord?.id),
        formState: {
          firstName: customer?.firstName ?? '',
          lastName: customer?.lastName ?? '',
          email: customer?.email ?? '',
          phoneNumber: customer?.phoneNumber ?? ''
        }
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}



export function useSaveCustomer(customerId: string) {
  const [fnMutate, tuple] = useSaveCustomerMutation({});

  const fnWrappedMutate = React.useCallback(
    async (formState: types.IFormState) => {
      await errorUtil.errorWrap(async () => {
        await fnMutate({
          variables: {
            input: {
              id: customerId,
              firstName: formState.firstName,
              lastName: formState.lastName,
              email: formState.email,
              phoneNumber: formState.phoneNumber
            }
          }
        });
      });
    },
    [
      customerId,
      fnMutate
    ]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
